/**
 * Returns a list of all valid sell options for a deviation.
 *
 * Relies on extended deviation data being loaded.
 */ export function getSellableAs(item) {
    var _item_extended;
    var _item_extended_sellableAs;
    return (_item_extended_sellableAs = (_item_extended = item.extended) === null || _item_extended === void 0 ? void 0 : _item_extended.sellableAs) !== null && _item_extended_sellableAs !== void 0 ? _item_extended_sellableAs : [];
}
export function getIsStash(item) {
    return !!item.stashPrivateid;
}
export function getDreamupPrompt(item) {
    var _item_extended_dreamsofart, _item_extended;
    return (_item_extended = item.extended) === null || _item_extended === void 0 ? void 0 : (_item_extended_dreamsofart = _item_extended.dreamsofart) === null || _item_extended_dreamsofart === void 0 ? void 0 : _item_extended_dreamsofart.prompt;
}
/**
 * Returns `true` if the supplied deviation is an adoptable that has been traded.
 *
 * NOTE: This function isn't accurate if an adoptable has been sold, then re-bought by the original author. Product has
 * accepted us ignoring this edge case.
 */ export function getHasBeenTraded(item) {
    var _item_adoptable;
    return ((_item_adoptable = item.adoptable) === null || _item_adoptable === void 0 ? void 0 : _item_adoptable.owner) && item.author && item.adoptable.owner.userId !== item.author.userId;
}

//# sourceMappingURL=getters.js.map